module.exports = __webpack_public_path__ + "img/Guirlande.f71b86b.jpg";